import { createSlice } from "@reduxjs/toolkit";
import { branchDepartmentThunk, departmentThunk, branchThunk, addBranchThunk, addDepartmentThunk, addBranchDepartmentThunk, uploadFileThunk } from "./generalThunk";

const initialState = {
    status: "idle",
    error: null,
    success: "",
    branches: [],
    departments: [],
    branchDepartments: [],
    media_files: [],
    profileDetails: [],
};

const generalSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.profileDetails = action.payload;
        },
        resetGeneralState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(branchThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(branchThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.branches = action.payload;
            })
            .addCase(branchThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            .addCase(departmentThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(departmentThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.departments = action.payload;
            })
            .addCase(departmentThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

            .addCase(branchDepartmentThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(branchDepartmentThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.branchDepartments = action.payload;
            })
            .addCase(branchDepartmentThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            // Add the Branch
            .addCase(addBranchThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addBranchThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addBranchThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            // Add the DepartmentThunk
            .addCase(addDepartmentThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addDepartmentThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addDepartmentThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            // Add the addBranchDepartmentThunk
            .addCase(addBranchDepartmentThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addBranchDepartmentThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addBranchDepartmentThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            // Add the uploadFileThunk
            .addCase(uploadFileThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(uploadFileThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.media_files = action.payload.data;
            })
            .addCase(uploadFileThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })
    },
});

export const { setUserDetails ,resetGeneralState } = generalSlice.actions;
export default generalSlice.reducer;
